import { VariationForm } from "./Woocommerce/VariationForm.js"
import { VatToggle } from "./Woocommerce/VatToggle.js"
import { Filters } from "./Woocommerce/Archive/Filters.js"
import { ProductListing } from "./Woocommerce/Archive/ProductListing.js"
import { CustomShop } from "./Woocommerce/Archive/CustomShop.js"
import { LatestProducts } from "./Woocommerce/Archive/LatestProducts.js"
import { Categories } from "./Woocommerce/Archive/Categories.js"
import { ProductSpecs } from "./Woocommerce/ProductSpecs.js"
import { register } from "swiper/element/bundle"
import { CartIcon } from "./Woocommerce/CartIcon.js"
import { ProductImages } from "./Woocommerce/ProductImages.js"
import { GoogleAnalytics } from "./tracking/GoogleAnalytics.js"
import { Search } from "./Site/Search.js"
const { apiFetch } = window.wp

register()

// Custom Elements
customElements.define("cf-filters", Filters)
customElements.define("product-listing", ProductListing)
customElements.define("custom-archive", CustomShop)
customElements.define("variation-form", VariationForm)
customElements.define("vat-toggle", VatToggle)
customElements.define("latest-products", LatestProducts)
customElements.define("product-categories", Categories)
customElements.define("product-specs", ProductSpecs)
customElements.define("product-images", ProductImages)
customElements.define("cart-icon", CartIcon)
customElements.define("purchase-tracker", GoogleAnalytics)
customElements.define("search-form", Search)

// Global Event Listeners
document.addEventListener("DOMContentLoaded", function () {
	const spinningLogos = document.querySelectorAll(".spinning-logo")
	document.addEventListener("scroll", function () {
		spinningLogos.forEach(logo => {
			logo.classList.add("scrolling")
		})
	})

	document.addEventListener("scrollend", function () {
		spinningLogos.forEach(logo => {
			logo.classList.remove("scrolling")
		})
	})

	if (window.gtag) {
		document.addEventListener("click", function (e) {
			const target =
				e.target.nodeName === "A" ? e.target : e.target.closest("a")
			if (target) {
				const href = target.getAttribute("href")
				// track phone and email link clicks
				if (href && (href.startsWith("tel:") || href.startsWith("mailto:"))) {
					let linkType = href.startsWith("tel:") ? "telefonsamtal" : "mail"
					gtag("event", linkType)
				}
			}
		})
	}

	document.addEventListener("cart-updated", function (e) {
		jQuery(document.body).trigger("wc_fragment_refresh")
	})

	document.querySelectorAll("form.elementor-form").forEach(form => {
		form.addEventListener("submit", function () {
			if (window.gtag) {
				gtag("event", "form_submit", {
					event_category: "Formulär",
					event_label: form.getAttribute("name") || "Okänt formulär",
				})
			}
		})
	})
})
